module.exports = __webpack_public_path__ + "static/media/shape1_1.a453a5bd.obj";